import Vue from 'vue'
import qs from 'qs'

import { baseUrl } from '@/config'

export default {
    login({ state, commit, dispatch }, payload) {
        let user = {
            username: payload.username,
            password: payload.password,
            client_id: 'yt-ios-app',
            client_secret: 'C45647N57J87J5B456N677HG5',
            grant_type: 'password',
            scope: '*'
        }

        const requestOptions = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        const dataUrl = qs.stringify(user)

        console.log('isAuthenticated', state.auth.isAuthenticated())
        return state.auth
            .login(dataUrl, requestOptions)
            .then(response => {
                console.log('response', response)

                commit('setAuth', Vue.prototype.$auth)
                window.localStorage.setItem(
                    'yt-authenticate.yt_refresh_token',
                    response.data.refresh_token
                )

                // Pre loaded User Profile
                dispatch('app/getUserProfile')
                // Pre loaded schools list app
                dispatch('app/getSchools')
            })
            .catch(error => {
                throw error
            })
    },
    logout({ state, commit }) {
        return state.auth.logout().then(() => {
            commit('setAuth', Vue.prototype.$auth)
            commit('app/reset', {})
        })
    },
    refreshToken({ state, commit }) {
        commit('setRunRefreshToken', true)

        const dataRequest = {
            client_id: 'yt-ios-app',
            client_secret: 'C45647N57J87J5B456N677HG5',
            grant_type: 'refresh_token',
            refresh_token: window.localStorage.getItem(
                'yt-authenticate.yt_refresh_token'
            )
        }

        const requestOptions = {
            url: `${baseUrl}oauth/refreshToken`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        return state.auth
            .login(qs.stringify(dataRequest), requestOptions)
            .then(response => {
                commit('setRunRefreshToken', false)
                commit('setAuth', Vue.prototype.$auth)
                window.localStorage.setItem(
                    'yt-authenticate.yt_refresh_token',
                    response.data.refresh_token
                )
            })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js